<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FJpfTk/tc-custom/9781497686922.jpg?1701061235170" alt="This image is the cover for the book Testing of Tertius, Merlin's Mistake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Testing of Tertius, Merlin's Mistake
      </h1>
      <p class="bookDescription body article font2">
        <b>Brian and Tertius are back, but this time, the stakes are higher than ever </b><br/><br/> When Brian and Lianor receive a coded message for Merlin, the know it’s urgent that they take it to him at once. Merlin’s apprentice, Tertius, couldn’t be happier to see them, but Merlin quickly realizes that the news is more serious than anyone could have imagined: the dark wizard Urlik is back, and he has vowed to take over King Arthur’s empire and destroy all who oppose him. As Merlin attempts to contact an old mentor, he is tricked and falls under Urlik’s spell. Without Merlin, how will the three stand against the most evil power England has ever known?<br/>  <br/> It’s up to Brian, Tertius, Lianor, and their friends to rescue Merlin and save their world from Urlik’s wicked plans. But the wizard is cunning, and it will take all their strength, skills, and smarts—and a little help from King Arthur himself—to have even a hope of triumphing over evil.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Newman
      </h2>
      
      <p class="authorDescription body article">Born in New York City, Robert Newman (1909&ndash;1988) was among the pioneers of early radio and was chief writer for the <I>Inner Sanctum Mysteries</I> and <I>Murder at Midnight</I>&mdash;forerunners of <I>The Twilight Zone</I> that remain cult favorites to this day. In 1944 Newman was put in charge of the radio campaign to reelect Franklin D. Roosevelt. He was also one of the founding members of the Radio Writers Guild, which became the Writers Guild of America.<BR /><BR /> In 1973 Newman began writing books for children, most notably the&#160;Andrew Tillet, Sara Wiggins&#160;&amp; Inspector Wyatt mysteries. The series takes place in Victorian London and follows the adventures of two teenage amateur detectives who begin as&#160;Baker Street Irregulars. Newman has also written books of fantasy, among them<I>&#160;Merlin&rsquo;s Mistake&#160;</I>and <I>The Testing of Tertius</I>.&#160;His books based on myths and folklore include&#160;<I>Grettir</I><I>the Strong</I>, and he has published two adult novels.<BR /> Newman was married to the writer Dorothy Crayder. Their daughter, Hila Feil, has also published novels for children and young adults. Newman lived his last days in Stonington, Connecticut.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62a0f73a